export enum ViewerScope {
  STAFF = 'staff',
  STUDENT = 'student',
}
